import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import { SelectMultiValue } from '../SelectMultiValue';

export const SortableMultiValue = SortableElement((props) => <SelectMultiValue {...props} />);
